<template>
  <div>
    <header>
      <HeaderSpecial />
      <BreadcrumbList />
    </header>

    <div id="main">
      <section class="spExhibition">
        <div class="spExhibitionTitle">
          <div class="inner4">
            <h1>特別展示</h1>
            <p class="titleSub">Special Exhibition</p>
          </div><!-- /inner4-->
        </div><!-- /spExhibitionTitle-->

        <div class="spExhibitionAbout">
          <div class="inner4">
            <p>
              サポート企業様、省庁・自治体様のご提供によるオンライン特別展示です。各企業様、省庁・自治体様より、珠玉の10作品を選定いただきました。ここにも、世界のあらゆる美しさを表現した作品が展示されています。解説やコメントもいただいておりますので、是非お目通しいただき、作品をより深く味わってみてください。スマートフォンの画面で鑑賞した方は、ぜひパソコンやタブレットなどの大きい画面でもお楽しみください。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAbout-->

        <div v-if="!isDemo()" class="spExhibitiontBody">
          <div class="inner2">

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/120"><img class="spExhibitionLogo horizontal"
                    src="/img_logo/120.jpg" :alt="this.getSp(120, 'name')" /></router-link></div>
              <h2>{{this.getSp(120, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/160"><img class="spExhibitionLogo vertical"
                    src="/img_logo/160.jpg" :alt="this.getSp(160, 'name')" /></router-link></div>
              <h2>{{this.getSp(160, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/130"><img class="spExhibitionLogo horizontal"
                    src="/img_logo/130.jpg" :alt="this.getSp(130, 'name')" /></router-link>
              </div>
              <h2>{{this.getSp(130, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/170"><img class="spExhibitionLogo horizontal"
                    src="/img_logo/170.jpg" :alt="this.getSp(170, 'name')" /></router-link></div>
              <h2>{{this.getSp(170, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/100"><img class="spExhibitionLogo square"
                    src="/img_logo/100.jpg" :alt="this.getSp(100, 'name')" /></router-link></div>
              <h2>{{this.getSp(100, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/150"><img class="spExhibitionLogo square"
                    src="/img_logo/150.jpg" :alt="this.getSp(150, 'name')" /></router-link></div>
              <h2>{{this.getSp(150, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"> <router-link to="/specials/140"><img class="spExhibitionLogo horizontal"
                    src="/img_logo/140.jpg" :alt="this.getSp(140, 'name')" /></router-link></div>
              <h2>{{this.getSp(140, 'name')}}</h2>
            </div><!-- /listBlock-->

            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/specials/110"><img class="spExhibitionLogo horizontal"
                    src="/img_logo/110.jpg" :alt="this.getSp(110, 'name')" /></router-link></div>
              <h2>{{this.getSp(110, 'name')}}</h2>
            </div><!-- /listBlock-->

          </div><!-- /inner-->
        </div><!-- /spExhibitiontBody-->
        <div v-else style="height: 500px; color: black; font-size: 3rem; padding-top: 100px; text-align: center;">
          Coming Soon
        </div>
      </section><!-- /spExhibition-->
    </div><!-- /main-->
    <Footer />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSpecial from '@/components/modules/HeaderSpecial.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    HeaderSpecial,
    Footer,
    BreadcrumbList,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'specialExhibitions',
      'specialExhibitionById'
    ])
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    getSp (id, key) {
      const obj = this.specialExhibitionById(id)
      return obj && obj[key] ? obj[key] : ''
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
  }
}
</script>

<style scoped>
</style>
